import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

/**
 * Custom hook to detect unsaved changes in Resource Budget
 * Returns true if there are unsaved changes and user is on resource budget page
 */
export const useUnsavedChanges = () => {
  const location = useLocation()
  const resourceBudgetState = useSelector((state: any) => state.resourceBudget)

  // Check if we're on the resource budget page
  const isOnResourceBudget = location.pathname === "/resource-budget"

  // Check if there are any unsaved changes
  const hasUnsavedChanges =
    isOnResourceBudget &&
    (resourceBudgetState.editState.allChanges.length > 0 ||
      resourceBudgetState.editState.clinicalDoctors.data.length > 0 ||
      resourceBudgetState.editState.clinicalHygienists.data.length > 0 ||
      resourceBudgetState.editState.nonClinical.data.length > 0 ||
      resourceBudgetState.editState.clinicalDoctors.dirty.length > 0 ||
      resourceBudgetState.editState.clinicalHygienists.dirty.length > 0 ||
      resourceBudgetState.editState.nonClinical.dirty.length > 0 ||
      resourceBudgetState.editState.dirty.length > 0 ||
      resourceBudgetState.editState.newEntry ||
      resourceBudgetState.editState.clinicalDoctors.newEntry ||
      resourceBudgetState.editState.clinicalHygienists.newEntry ||
      resourceBudgetState.editState.nonClinical.newEntry)

  return {
    hasUnsavedChanges: !!hasUnsavedChanges,
    isOnResourceBudget,
  }
}

export default useUnsavedChanges
